import { Button } from '@idexx-laboratories/spot-react';
import { observer } from 'mobx-react';
import React, { useEffect, useRef } from 'react';
import Grid from '../../components/Grid/Grid';
import { useStore } from '../../hooks/use-store';

const UpdateUpgradeVersionsContent = observer(() => {
  const { manageUpgradeVersionsStore: store, globalStore } = useStore();
  const { addUsersColDef, editObjects } = store;
  const fileInput = useRef<HTMLInputElement>(null);

  useEffect(() => {
    store.init();
  }, [globalStore.globalModalProps, store]);

  const handleClickUpload = () => {
    if (fileInput?.current) {
      fileInput.current.click();
    }
  };

  const onFileChange = (event: any) => {
    void store.processSapVersionsFile(event.target.files[0]);
    event.target.value = '';
  };

  return (
    <div className='update-sap-versions'>
      <Button variant='primary' size='small' aria-label='Upload CSV' onClick={handleClickUpload}>
        Upload CSV file
      </Button>
      <span>
        File should contain the following column headers:
        <strong> SAP ID</strong>,<strong> CS Version</strong>
      </span>
      <input
        type='file'
        accept='text/csv'
        ref={fileInput}
        role='file-input'
        onChange={onFileChange}
      />
      <Grid
        id='user-management-update-sap-versions-users-grid'
        columns={addUsersColDef}
        data={editObjects.map(o => o.item)}
      />
    </div>
  );
});

export default UpdateUpgradeVersionsContent;
